import { createAsyncThunk } from "@reduxjs/toolkit";
import { dataServer, fetchDummyData, isProduction } from "~/constants";
import { fetchOrganizationData, fetchOrganizationInfoData, fetchOrganizationtechInfoData } from "~/slices/demiData";
import { updatePromise } from "./updateThunks";

// Async thunk to fetch organization data
export const fetchOrganization = createAsyncThunk(
  "organization/fetchOrganization",
  async (params: { orgId: number, providerId: number | null }, { rejectWithValue }) => {
    const { orgId, providerId } = params;
    console.log("fetchOrganization params", { orgId, providerId });
    
    if (fetchDummyData) return fetchOrganizationData
    let time = new Date().getTime();
    try {
      const response = await fetch(`${dataServer}organizations/${orgId}?provider_id=${providerId}&data=basic`);
      if (!response.ok) {
        throw new Error("Failed to fetch organization");
      }
      time = new Date().getTime() - time;
      // console.log("fetchOrganization time", time);
      return await response.json();
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);
export const fetchOrganizationDataType = createAsyncThunk(
  "organization/fetchOrganizationDataType",
  async (params: { orgId: number, providerId: number | null, dataType: 'assets' | 'surveys' }, { rejectWithValue }) => {
    const { orgId, providerId, dataType } = params;
    console.log("fetchOrganization params", { orgId, providerId, dataType });
    // if (fetchDummyData) return fetchOrganizationData
    let time = new Date().getTime();
    try {
      const response = await fetch(`${dataServer}organizations/${orgId}/${dataType}?provider_id=${providerId}`);
      if (!response.ok) {
        throw new Error("Failed to fetch organization");
      }
      time = new Date().getTime() - time;
      console.log("fetchOrganizationDataType time", time);
      const data = await response.json();
      console.log("Raw data:", data); // Log the raw response text
      return {
        dataType,
        data,
      };
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);
export const fetchOrganizationInfo = createAsyncThunk(
  "organization/fetchOrganizationInfo",
  async (params: { orgId: number, providerId?: number | null }, { rejectWithValue }) => {
    const { orgId, providerId } = params;
    if (!isProduction) return fetchOrganizationInfoData
    let time = new Date().getTime();
    try {
      const providerQuery = providerId ? `?provider_id=${providerId}` : '';
      const response = await fetch(`${dataServer}organizations/${orgId}/info${providerQuery}`);
      if (!response.ok) {
        throw new Error("Failed to fetch organization info");
      }
      time = new Date().getTime() - time;
      console.log("fetchOrganizationInfo time", time);
      return await response.json();
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);
export const fetchProviderInfo = createAsyncThunk(
  "organization/fetchProviderInfo",
  async (providerId: number, { rejectWithValue }) => {
    // if (!isProduction) return fetchOrganizationInfoData

    try {
      const response = await fetch(`${dataServer}providers/${providerId}/info`);
      if (!response.ok) {
        throw new Error("Failed to fetch provider info");
      }
      return await response.json();
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);
export const fetchOrganizationTechInfo = createAsyncThunk(
  "organization/fetchOrganizationTechInfo",
  async (orgId: number, { rejectWithValue }) => {
    if (fetchDummyData) return fetchOrganizationtechInfoData
    let time = new Date().getTime();
    try {
      const response = await fetch(`${dataServer}organizations/${orgId}/tech-info`);
      if (!response.ok) {
        throw new Error("Failed to fetch organization info");
      }
      time = new Date().getTime() - time;
      console.log("fetchOrganizationTechInfo time", time);
      return await response.json();
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);


